import AuthLayout from "../../layouts/Auth.layout";
import { useGetUserQuery } from "../../store/services/user";
import { AuthWrapper, AddNumberForm } from "../../components/forms/auth";

export const AddNumber = () => {
  const { data } = useGetUserQuery();

  return (
    <AuthLayout>
      <AuthWrapper form={<AddNumberForm />}>
        <div className="font-manrope text-base text-gray-300 flex flex-row gap-x-6 mb-8">
          Welcome, {data?.first_name}! Just one more step before you can create
          an invoice.
        </div>
        <div className="font-poppins text-5xl	text-gray-500">
          Add your
          <br />
          number
        </div>
      </AuthWrapper>
    </AuthLayout>
  );
};
